import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {encryptStorage} from 'src/app/auth/utils/storage';
import {showDefaultError, showError, showNotification} from 'src/app/shared/utils/functions/notification.function';
import {PerfilService} from '../../services/perfil.service';
import {UserType} from "../../../shared/enum/investor-type.enum";
import {CognitoService} from "../../../shared/services/cognito.service";

@Component({
  selector: 'app-home-investidor-dpge',
  templateUrl: './home-investidor-dpge.component.html',
  styleUrls: ['./home-investidor-dpge.component.scss']
})
export class HomeInvestidorDpgeComponent implements OnInit {

  cardInstituicoes: any[] = []

  tipoCognito: string = ''
  textoTipoUserCognito: string = ''
  textoTipoUserCognitoInvestidor: string = 'INVESTIDOR'
  textoTipoUserCognitoEntidade: string = 'CORRETORA/ADM. FUNDOS/DTVM'
  textoTipoUserCognitoInvestidorFI: string = 'FUNDO DE INVESTIMENTOS'
  textoTipoUserCognitoIndefinido: string = 'INDEFINIDO'
  textoTipoUserCognitoPF: string = 'PESSOA FÍSICA';
  textoTipoUserCognitoPJ: string = 'PESSOA JURÍDICA';

  constructor(
    private perfilService: PerfilService,
    private cognitoService: CognitoService,
    private router: Router,
  ) {
  }

  ngOnInit(): void {
    this.listarSolicitacoes();

    this.tipoCognito = encryptStorage.getItem('@tipoUsuario', false);

    switch (this.tipoCognito) {
      case UserType.Investment:
        this.textoTipoUserCognito = this.textoTipoUserCognitoInvestidor;
        break;
      case UserType.InvestmentPf:
        this.textoTipoUserCognito = this.textoTipoUserCognitoPF;
        break;
      case UserType.InvestmentPj:
        this.textoTipoUserCognito = this.textoTipoUserCognitoPJ;
        break;
      case UserType.Entity:
        this.textoTipoUserCognito = this.textoTipoUserCognitoEntidade;
        break;

      case UserType.InvestmentFund:
        this.textoTipoUserCognito = this.textoTipoUserCognitoInvestidorFI;
        break;
      case UserType.Undefined:
        this.textoTipoUserCognito = this.textoTipoUserCognitoIndefinido;
        break;
      default:
        this.textoTipoUserCognito = this.textoTipoUserCognitoIndefinido;
    }
  }

  listarSolicitacoes() {
    return this.perfilService.consultaDisponibilidadeDPGE().subscribe(
      res => this.cardInstituicoes = res["data"],
      e => showDefaultError(e))
  }


  solicitarConsultaGarantia(data) {
    var cnpjEscolhidoGarantiaDPGE = data.cnpjEmpresaCredor
    var nomeEscolhidoGarantiaDPGE = data.nomeEmpresaCredor

    return this.perfilService.consultaDisponibilidadeGarantiaDPGE(data.instituicaoId, cnpjEscolhidoGarantiaDPGE).subscribe(res => {
      this.router.navigate(['/spg/consulta-solicitar-dpge'])
      localStorage.setItem('nomeInstituicao', data.nome)
      localStorage.setItem('dataLiquidacao', data.liquidacao)
      localStorage.setItem('id', data.instituicaoId)
      localStorage.setItem('cnpjEscolhidoGarantiaDPGE', cnpjEscolhidoGarantiaDPGE)
      localStorage.setItem('nomeEscolhidoGarantiaDPGE', nomeEscolhidoGarantiaDPGE)
    }, e => {
      if (e.status == 422) {
        return showNotification('', e['error']['data']['detalhesErro'])
      }
      return showError('', "Ocorreu um erro na solicitação, por favor tente novamente em alguns instantes")
    }, () => {

    })
  }

  trocarTipoCognito() {
    const attributes = {
      "custom:user_type": UserType.Undefined,
    };

    this.cognitoService.update(attributes).subscribe(
      () => {
        encryptStorage.setItem('@tipoUsuario', UserType.Undefined, false);
        this.router.navigate(['/complemento-cadastro']);
      },
      (e) => showDefaultError(e)
    );
  }
}
